/* unplugin-vue-components disabled */import { render } from "./AIModePicker.vue?vue&type=template&id=48499896&scoped=true&ts=true"
import script from "./AIModePicker.vue?vue&type=script&lang=ts"
export * from "./AIModePicker.vue?vue&type=script&lang=ts"

import "./AIModePicker.vue?vue&type=style&index=0&id=48499896&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48499896"]])

export default __exports__